export const CHAR_LIMIT = 500;
export const ANSWERS_LIMIT = 255;
